/**
 * Generische Toggle-Logik für EU-Compliance-Komponenten
 * (GARAN-Label und Gewährleistungs-Mitteilung).
 *
 * Anforderung lt. Durchführungsverordnung (EU) 2025/1960, Anhang II, für
 * das GARAN-Label: vollständige Anzeige beim ERSTEN Klick, Hover oder
 * Touch. Für die Gewährleistungs-Mitteilung (Anhang I) ist eine
 * Klick-Anzeige nicht ausdrücklich vorgesehen - wird hier aus
 * Praktikabilität gleich behandelt, aber siehe Hinweis in
 * legal-guarantee-notice.liquid: das vor dem Live-Schalten rechtlich
 * gegenprüfen lassen.
 *
 * FIX (siehe Chat): mouseleave allein reicht auf Touch-Geräten nicht zum
 * Schliessen, da dort kein "Verlassen mit der Maus" existiert. Zusaetzlich
 * zu mouseleave schliesst jetzt ein Tap/Klick ausserhalb der Komponente
 * (fuer Komponenten OHNE eigenen Backdrop, z.B. das GARAN-Popover - die
 * Gewährleistungs-Mitteilung hat weiterhin ihren eigenen Backdrop-Klick,
 * der unveraendert funktioniert).
 *
 * FIX (siehe Chat): Komponenten mit Backdrop (aktuell nur die
 * Gewährleistungs-Mitteilung) werden beim ersten Öffnen an das Ende von
 * <body> verschoben. Grund: "position: fixed" zentriert nur relativ zum
 * Viewport, wenn KEIN Vorfahre im DOM ein CSS-"transform" (o.ä., z.B. fuer
 * Sticky-/Animationseffekte) gesetzt hat - hat ein Vorfahre irgendwo im
 * Theme sowas, "faengt" der das fixed-Element ein und es erscheint an
 * falscher Position statt zentriert. Anhaengen an <body> umgeht das
 * zuverlaessig, unabhaengig davon, wo die Komponente im Theme eingebunden
 * wird.
 */
document.addEventListener('DOMContentLoaded', function () {
  var openWithoutBackdrop = [];

  document.querySelectorAll('[data-eu-toggle]').forEach(function (wrapper) {
    var trigger = wrapper.querySelector('[data-eu-toggle-trigger]');
    var target = wrapper.querySelector('[data-eu-toggle-target]');
    var closeBtn = wrapper.querySelector('[data-eu-toggle-close]');
    var backdrop = wrapper.querySelector('[data-eu-toggle-backdrop]');
    var movedToBody = false;

    if (!trigger || !target) return;

    function open() {
      if (backdrop && !movedToBody) {
        document.body.appendChild(backdrop);
        document.body.appendChild(target);
        movedToBody = true;
      }
      target.hidden = false;
      if (backdrop) backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (!backdrop && openWithoutBackdrop.indexOf(wrapper) === -1) {
        openWithoutBackdrop.push(wrapper);
      }
    }
    function close() {
      target.hidden = true;
      if (backdrop) backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      var idx = openWithoutBackdrop.indexOf(wrapper);
      if (idx !== -1) openWithoutBackdrop.splice(idx, 1);
    }

    trigger.addEventListener('click', open);
    if (!wrapper.hasAttribute('data-eu-toggle-click-only')) {
      trigger.addEventListener('mouseenter', open);
    }
    trigger.addEventListener('focus', open);
    trigger.addEventListener('touchstart', open, { passive: true });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    // Weiterhin fuer Desktop/Maus: beim Verlassen der Wrapper-Flaeche
    // sofort schliessen (nur relevant bei Komponenten ohne Backdrop UND
    // ohne "nur Klick"-Modus - bei reinem Klick soll Maus-weg-bewegen
    // nicht automatisch schliessen, nur Klick ausserhalb/Escape/X).
    if (!backdrop && !wrapper.hasAttribute('data-eu-toggle-click-only')) {
      wrapper.addEventListener('mouseleave', close);
    }

    wrapper.__euToggleClose = close;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  // Tap/Klick ausserhalb einer offenen Komponente OHNE Backdrop schliesst
  // sie - das faengt genau den Touch-Fall ab, den mouseleave nicht abdeckt.
  document.addEventListener('touchstart', handleOutside, { passive: true });
  document.addEventListener('click', handleOutside);

  function handleOutside(event) {
    if (!openWithoutBackdrop.length) return;
    openWithoutBackdrop.slice().forEach(function (wrapper) {
      if (!wrapper.contains(event.target) && wrapper.__euToggleClose) {
        wrapper.__euToggleClose();
      }
    });
  }
});
